import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../lib/loopback'
import { path } from 'ramda'

const metasAnalistaRepository = createRepository({
  path: 'metas-analista',
  parentPath: 'analistas',
  relationType: 'path',
  restApi,
  queryTransform: {
    ...paginate
  },
  getErrorMessage: response => path(['data', 'error', 'message'], response)
})

metasAnalistaRepository.remove = async ({ id }) => {
  if (!id) throw new Error('ID é obrigatório para delete')
  const uri = `metas-analista/${id}`
  const response = await restApi.delete(uri)
  return {
    ok: response.ok,
    data: response.data
  }
}

metasAnalistaRepository.getOne = ({ id }) => {
  return restApi.get(`metas-analista/${id}`)
}

export default metasAnalistaRepository
